import clsx from 'clsx';
import type { CSSProperties, FunctionComponent, HTMLAttributes } from 'react';

const skeletonBaseClasses =
    'animate-shimmer bg-linear-to-r from-gray-200 via-gray-300 to-gray-200 [background-size:1000px_100%] rounded-md';

export const SkeletonBase: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
    <div className={clsx(skeletonBaseClasses, className)} {...props} />
);

type SkeletonProps = {
    readonly borderRadius?: string;
    readonly className?: string;
    readonly height?: string;
    readonly style?: CSSProperties;
    readonly width?: string;
};

export const Skeleton: FunctionComponent<SkeletonProps> = ({ borderRadius, className, height, style, width }) => (
    <div
        className={clsx(skeletonBaseClasses, className)}
        data-testid="skeleton"
        style={{ borderRadius, height, width, ...style }}
    />
);
